import { Route } from '@angular/router';
import { HandlerErrorComponent } from './handler-error.component';

export const handlerRoutes: Route[] = [
  { path: 'error', component: HandlerErrorComponent },
  { path: 'error/:statusText/:status/:message', component: HandlerErrorComponent }
];
